import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=1d489d27"
import script from "./modal.ts?vue&type=script&lang=js&external"
export * from "./modal.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports